import React from "react";
import { OrdersToolbarProps } from "../../../../shared/services/interface";
import SearchField from "./SearchField";
import ImportButton from "./ImportButton";
import ExportSelect from "./ExportSelect";
import FilterSelect from "./FieldSelect";

const OrdersToolbar: React.FC<OrdersToolbarProps> = ({
  searchTerm,
  handleSearch,
  inputRef,
  handleImport,
  handleExport,
  orders,
  selectedDate,
  selectedDate2,
  selectedOption,
  handleFilterChange,
}) => {
  return (
    <div className="w-full mx-auto px-4">
      <div className="toolbar-order-wrapper">
        <div className="toolbar-layout">
          <SearchField searchTerm={searchTerm} handleSearch={handleSearch} />
          <ImportButton inputRef={inputRef} handleImport={handleImport} />
          <FilterSelect
            selectedOption={selectedOption}
            handleFilterChange={handleFilterChange}
          />
          <ExportSelect
            orders={orders}
            selectedDate={selectedDate}
            selectedDate2={selectedDate2}
            handleExport={handleExport}
          />
        </div>
      </div>
    </div>
  );
};

export default OrdersToolbar;
